export const environment = {
  production: true,
  testing: false,
  version: 'v1.2.1',
  assets: '../../src/assets/',
  assetsSub: '../',
  clientId: 'f77d41e2-bc62-4b0d-ad00-de367ead6ca1',
  authority: 'https://login.microsoftonline.com/a4d2a09c-1ee5-4505-a0ae-73eed45d4091',
  redirectUri: 'https://macsafety.macmiller.com',
  postLogoutRedirectUri: 'https://macsafety.macmiller.com',
  apiBaseUrl: 'https://macsafety-api.macmiller.com',
  apiScope: ["api://f77d41e2-bc62-4b0d-ad00-de367ead6ca1/MacSafety.Read", 
    "api://f77d41e2-bc62-4b0d-ad00-de367ead6ca1/MacSafety.Readwrite"],
  adGeneralGroup: 'Entra-MacSafety',
  adPfizerFormAccessGroup: 'Entra-MacSafety-Pfizer-Access',
  adAdminGroup: 'Entra-MacSafety-Admins',
  templateEditorsGroup: 'Entra-MacSafety-Template-Editors',
  noFormRequirements: false,
    useTestUser: false,

  
};